export const BORDER_PADDING = 8;
export const INSIDE_PADDING = 4;
export const SPACE_BETWEEN_NUMBERS = 2;
